import { render, staticRenderFns } from "./TrainingsView.vue?vue&type=template&id=2659fd31&scoped=true&"
import script from "./TrainingsView.vue?vue&type=script&lang=ts&"
export * from "./TrainingsView.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingsView.vue?vue&type=style&index=0&id=2659fd31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2659fd31",
  null
  
)

export default component.exports